import { createFileRoute, redirect } from '@tanstack/react-router';

import { useUiStore } from '@/features/settings/ui-store.js';
import { useChatSessionStore } from '@/integration/state/chat-session-store.js';

/**
 * Legacy `/projects/:id` URL — after the workspace cutover the same uuid is the workspace id
 * (1:1 from the adoption migration). Select that workspace, clear any stale chat session, and land on
 * chats. Uses a `system` reason so the `/chats` workspace-switch effect does not treat this like a
 * sidebar switch (which would navigate to `/home`).
 */
export const Route = createFileRoute('/projects/$id')({
  beforeLoad: ({ params }) => {
    useChatSessionStore.getState().setActiveConversationId(null);
    useChatSessionStore.getState().setStreamingConvId(null);
    useUiStore.getState().setSelectedWorkspaceId(params.id, 'system');
    throw redirect({ to: '/chats', replace: true });
  },
});
